export * from './uploader.component';
